import type { EntitlementFieldData } from './types';

export const getNameFromFieldData = (value: EntitlementFieldData) => value?.product?.name;
